import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function GlobalNetwork() {
  const {
    t,
    tArray
  } = useLanguage();
  const locations = tArray<string>('globalNetwork.locations');
  return <section className="py-24 md:py-32 bg-navy text-ivory relative overflow-hidden" data-id="element-84">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4A853 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-85" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-88">
            <h2 className="text-3xl md:text-5xl font-heading text-warmWhite mb-6" data-id="element-89">
              {t('globalNetwork.title1')}{' '}
              <span className="text-saffron italic" data-id="element-90">
                {t('globalNetwork.title2')}
              </span>
            </h2>
            <p className="text-warmWhite/70 text-lg leading-relaxed mb-8" data-id="element-91">
              {t('globalNetwork.description')}
            </p>
            <div className="p-6 border border-gold/20 bg-ivory/5 rounded-sm backdrop-blur-sm" data-id="element-92">
              <p className="text-saffron font-medium" data-id="element-93">
                {t('globalNetwork.noteHighlight')}{' '}
                <span className="text-warmWhite/90 font-normal" data-id="element-94">
                  {t('globalNetwork.note')}
                </span>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-95">
            {locations.map((loc, idx) => <div key={idx} className="flex flex-col items-center justify-center p-6 border border-gold/10 bg-navy/50 rounded-sm hover:border-saffron/30 transition-colors" data-id="element-96">
                <GlobeIcon className="w-6 h-6 text-gold/50 mb-3" strokeWidth={1.5} data-id="element-97" />
                <span className="font-heading text-lg text-warmWhite/90 text-center" data-id="element-98">
                  {loc}
                </span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}